import { t } from 'i18next'
import { Chart } from 'primereact/chart'
import { Tooltip } from 'primereact/tooltip'
import React, { useEffect, useState } from 'react'
import { API_PERSONS_BY_ACCOUNT } from '../../../../constants'
import { RequestMethod, UserAccountType } from '../../../../model/enums/enums'
import { Person } from '../../../../model/person.model'
import { State } from '../../../../model/state.model'
import { handleRequest } from '../../../../services/api/base/handleRequest'

export const SizeBarStatistic = () => {
  const [people, setPeople] = useState<Person[]>([])
  const [notDefined, setNotDefined] = useState<string[]>([])

  const [sizeLabels] = useState([
    'XXS',
    'XS',
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    'XXXL',
    t<string>('core.statistic.unknown'),
  ])

  const [chartData, setChartData] = useState({
    labels: sizeLabels,
    datasets: [
      {
        type: 'bar',
        label: t<string>('core.statistic.count'),
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: 'rgb(0, 127, 192)',
        hoverBackgroundColor: '#fff',
      },
    ],
  })

  useEffect(() => {
    const getStatistics = () => {
      const genderSizes: any = { 1: [], 2: [], 3: [], 4: [] }
      const genderArray = [1, 2, 3, 4]
      // For statistic we need the detail information and need to query them again
      handleRequest<Person[]>(
        API_PERSONS_BY_ACCOUNT(UserAccountType.Apprentice),
        RequestMethod.GET
      ).then((personsResult: State<Person[]>) => {
        if (personsResult.data) {
          setPeople(personsResult.data)

          const notSetNames: string[] = []
          //  todo verify
          // eslint-disable-next-line array-callback-return
          genderArray.map((clothSizeIndex: number): void => {
            for (let i = 1; i < 10; i++) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              const filteredArray = personsResult.data.filter(
                (person: Person) => {
                  if (
                    person.salutation === clothSizeIndex &&
                    person.cloth_size === i
                  ) {
                    return true
                  }
                  if (
                    i === 9 &&
                    person.salutation === clothSizeIndex &&
                    !person.cloth_size
                  ) {
                    if (person.first_name) {
                      notSetNames.push(
                        `${person.first_name} ${person.last_name}`
                      )
                    }
                    return true
                  }
                  return false
                }
              )
              genderSizes[clothSizeIndex].push(filteredArray.length)
            }
            setNotDefined(notSetNames)
          })

          setChartData({
            labels: sizeLabels,
            datasets: [
              {
                type: 'bar',
                label: t('core.statistic.women'),
                data: genderSizes[1],
                backgroundColor: '#E0979E',
                hoverBackgroundColor: '#ffb0b8',
              },
              {
                type: 'bar',
                label: t('core.statistic.men'),
                data: genderSizes[2],
                backgroundColor: '#007FC0FF',
                hoverBackgroundColor: '#019ff1',
              },
              {
                type: 'bar',
                label: t('core.statistic.diverse'),
                data: genderSizes[3],
                backgroundColor: '#8d7a70',
                hoverBackgroundColor: '#c7afa2',
              },
              {
                type: 'bar',
                label: t('core.statistic.not_specified'),
                data: genderSizes[4],
                backgroundColor: '#87888AFF',
                hoverBackgroundColor: '#CBC8C8FF',
              },
            ],
          })
        }
      })
    }
    getStatistics()
    // cleanup
    return getStatistics
  }, [sizeLabels])

  const stackedOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1.2,
    plugins: {
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        labels: {
          color: '#495057',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#495057',
        },
        grid: {
          color: '#ebedef',
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: '#495057',
        },
        grid: {
          color: '#ebedef',
        },
      },
    },
  }

  return (
    <div className={'col card-hover'}>
      <h4 className={'statistic-text w-full'}>
        <>
          {t<string>('core.statistic.count_apprentices_sizes')}{' '}
          <span className={'ml-1'}>({people.length})</span>
        </>
      </h4>
      {notDefined.length > 0 && (
        <i
          className={
            'w-full fa-solid fa-info-circle icon-grey statistic-info-icon statistic-text'
          }
        />
      )}
      <div className={'grid justify-content-center align-items-center h-full'}>
        <Chart
          className={' w-full'}
          type={'bar'}
          options={stackedOptions}
          data={chartData}
        />
      </div>
      <Tooltip
        target={'.fa-info-circle'}
        showDelay={500}
        style={{ width: '400px' }}
        position={'bottom'}
        content={`${t<string>('core.statistic.unknown')}: ${notDefined.join(
          ', '
        )}`}
      />
    </div>
  )
}